export const useSelectTokenByPosition = (tokenGlobalPosition: number) => {
  const element = document.getElementById(`token-${tokenGlobalPosition}`);
  const childElement = element?.querySelector(".selection-layer");

  if (!childElement) return;

  const range = document.createRange(); // Create a Range object
  range.selectNodeContents(childElement); // Set the range to the content of the element

  const selection = window.getSelection(); // Get the current selection
  if (selection) {
    selection.removeAllRanges(); // Clear any existing selections
    selection.addRange(range); // Add the new range to the selection
  }
};
